import React, { useEffect } from "react";
import "../../App.css";
import ThesisImage from "../../images/Bilen_utanbakground.png";
import CarSketch from "../../images/thesis/CarSktech.png";
import CarModels from "../../images/thesis/carModels.png";
import "./Thesis.css";
import { useMediaQuery } from "react-responsive";
import DocumentIcon from "../../images/icons/document-icon.png";
import SectionBlock from "../sectionBlock/sectionBlock";
import ModelViewer from "../3d/ModelViewer";
import CarBack from "../../images/thesis/bilen-baifrån.png";

export default function Thesis() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  return (
    <div className="canea-container">
      {/* Header Section */}
      <div className="thesis-header-section">
        <div className="header-content">
          <div className="text-section">
            <h1 className="title">Electric Vehicle</h1>
            <p className="text">
              This project, conducted in collaboration with Cliff Design,
              explores a more environmentally friendly and space-efficient
              alternative to traditional cars for single households and
              individuals aged 18–35 by the year 2030. The goal was to create a
              vehicle that is “as little car as possible” while still appealing
              to current car users. Despite the fact that many car owners rarely
              utilize more than half of their vehicle’s full capacity, larger
              cars remain the preferred choice in Sweden. Through literature
              studies, trend analysis, and interviews, insights were gained into
              why this is the case, leading to the development of a concept
              aimed at encouraging both current and future car users to shift to
              more sustainable options.
            </p>
          </div>
          <img src={ThesisImage} className="header-image" alt="Master Thesis" />
        </div>
      </div>
      <div className="thesis-prototype-section">
        <div className="thesis-process-section">
          <div>
            <h1 className="title">Process</h1>
            <p className="text">
              The project process included a literature review on personal
              transportation, vehicle types, and user trends. A user study,
              consisting of a survey and interviews, was conducted to understand
              user preferences, leading to the creation of personas, a
              positioning diagram, and a requirements specification. Concept
              development involved idea generation, evaluation, and 3D modeling
              of the concept in Blender.
            </p>
          </div>
          <SectionBlock
            title="Literature Review and User Research"
            text="The project began by researching personal transportation to understand the current market, existing alternatives, and trends that will influence transportation in the future. The user research consisted of a survey and interviews. A total of 66 respondents (ages 16–79) answered the survey, which focused on travel distances and preferred modes of transport. Six semi-structured interviews were conducted with individuals aged 21–24 to explore their transportation choices and decision-making factors. Unstructured interviews with Clean Motion and Velove provided insights into the challenges small vehicles face in the market."
          />
          <SectionBlock
            title="Target Users"
            text="To design an appealing concept, it must target a specific audience. The nex step focused on defining the target audience to then conceptualize a vehicle tailored to their needs. Identifying target groups helps create concrete parameters for the project. Initially, the target audience included a broad group of people, which was then narrowed down, providing a clearer picture of who the project should be directed towards.
"
          />
          <SectionBlock
            title="Specifications"
            text="The requirements that the vehicle must meet to appeal to the target audience and comply with legal regulations were specified. Additionally, the type of vehicle, its passenger capacity, and the amount of luggage it should accommodate were defined."
          />
          <SectionBlock
            title="Concept Development"
            text="A concept was developed for the target audience through various forms of idea generation and evaluation. The focus was on how the vehicle should be designed to meet the requirements. Since the vehicle needed to be small and space-efficient, ideas were generated on how to optimize both the vehicle's shape and door mechanisms to take up minimal space. Due to its small size, a robust feel was required, and this was a key focus during idea generation, ensuring the vehicle felt sturdy yet agile. Ideas were also developed for making the interior flexible to accommodate different users and expand its functionality."
          />
        </div>
        {!isMobile && (
          <div className="thesis-image-container">
            <img src={CarSketch} className="thesis-image" alt="Master Thesis" />
            <img src={CarModels} className="thesis-image" alt="Master Thesis" />
          </div>
        )}
      </div>

      {/* Functional Prototype Section */}
      <div className="prototype-section">
        <h1 className="title">Final Concept</h1>
        <p className="text">
          With its minimal form, robust design, and flexible expression, the
          concept is aimed at the next generation of car owners who previously
          preferred owning a conventional car. This vehicle offers the
          opportunity to buy, lease, or rent, increasing its accessibility and
          usage. On a daily basis, it smoothly takes you to work, the gym, or
          the grocery store. On weekends, it takes you on local day trips with a
          range of up to 120 km. This compact vehicle provides 280 liters of
          space for everyday errands, and when more space is needed, the cargo
          area can be expanded to 560 liters by removing the modular seat. This
          small vehicle with a large range of uses could potentially replace
          larger cars in the Swedish market or serve as a step between a car and
          a bicycle.
        </p>
        {isMobile ? (
          <div className="concept-image-section">
            <img
              src={ThesisImage}
              className="final-concept-image"
              alt="Master Thesis"
            />
            <img
              src={CarBack}
              className="final-concept-image"
              alt="Master Thesis"
            />
          </div>
        ) : (
          <div className="model-container">
            <ModelViewer />
          </div>
        )}

        <p className="report-link">
          Check out the full report here:{" "}
          {isMobile ? (
            <a
              href="https://hdl.handle.net/20.500.12380/305397"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={DocumentIcon} alt="Report" className="document-icon" />
            </a>
          ) : (
            <a
              href="https://hdl.handle.net/20.500.12380/305397"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://hdl.handle.net/20.500.12380/305397
            </a>
          )}
        </p>
      </div>
    </div>
  );
}
